import React, { useState, useRef, useEffect } from 'react';
import { Typography, TypographyProps } from '@saucelabs/ds-typography';
import { Tooltip } from '@saucelabs/ds-tooltip';
import classnames from 'classnames';
import debounce from 'lodash.debounce';

import ConditionalWrapper from './ConditionalWrapper';

export type TruncateProps = {
  text?: string
  hideTooltip?: boolean
} & Omit<TypographyProps, 'children'>

const Truncate: React.FC<TruncateProps> = (props) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [truncated, setTruncated] = useState(false);
  const { text, hideTooltip, className: textClassnames, ...rest } = props;

  useEffect(() => {
    if (!elementRef?.current) {
      return;
    }

    const onResize = debounce(() => {
      if (elementRef?.current?.scrollWidth && elementRef?.current?.clientWidth) {
        setTruncated(elementRef?.current?.scrollWidth > elementRef?.current?.clientWidth);
      }
    }, 300);
    onResize();
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  if (!text) {
    return null;
  }

  return (
    <ConditionalWrapper
      condition={truncated && !hideTooltip}
      wrapper={(content) => (
        <Tooltip
          placement="top"
          title={text}
        >
          {content}
        </Tooltip>
      )}
    >
      <div className="flex min-w-0">
        <Typography
          ref={elementRef}
          className={classnames(textClassnames, 'truncate')}
          {...rest}
        >
          {text}
        </Typography>
      </div>
    </ConditionalWrapper>
  );
};

export default Truncate;
